import React from 'react';
import Header from './header'; // Assuming the Header component is in the same directory as App.js
import Landing from './landing';
import Footer from './footer';
import Education from './education';
import Projects from './projects';
import Separator from './separator';
import Pratical from './pratical';
import Tools from './tools';
import Free from './freelance';
import Content from './ContentCreator';


function Home() {
  return (
    <div>
        <Landing/>
        <Projects/>
        <Free/>
        <Tools/>
        <Separator/>
        <Pratical/>
        <Education/>
        <Content/>

    </div>
  );
}

export default Home;
